import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Grid, Typography, Button, useMediaQuery } from '@material-ui/core';

// UTILITY
import { checkIsAbsoluteUrl } from '@/utility/routes';
import { analyticsClickedToApp, externalLink, getExternalUrlParams } from '@/utility/analytics';
import { updateUrl } from '@/utility/common';

// COMPONENTS
import Link from '@/components/Link';

// STYLES
import { Container } from './styles';

const BannerDynamic = ({ data, analyticsProps, analyticsLocation }) => {
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));
  const { unique_id } = useSelector(({ auth }) => ({
    unique_id: auth.unique_id,
  }));

  function getImg() {
    const defImg = data.desktop_image || data.mobile_image;
    let img = defImg;

    if (!defImg) return null;

    if (downXs) img = data.mobile_image || data.desktop_image;

    return <img src={img} alt="banner" />;
  }

  function handleLinkClicked() {
    const properties = {
      ...analyticsProps,
      from_page_path: window.location.pathname,
      from_search_params: window.location.search,
      location: analyticsLocation,
      app_id: data.app_id,
    };

    analyticsClickedToApp(properties);
  }

  function handleExternalLinkClicked(href) {
    externalLink({ href, location: analyticsLocation });

    handleLinkClicked();
  }

  function getButton() {
    const url = data.cta_url;

    if (!url || !data.cta_text) return null;

    const externalUrlParams = getExternalUrlParams({ unique_id });
    const href = updateUrl(url, externalUrlParams);
    let btnProps = {
      component: Link,
      to: href,
      onClick: handleLinkClicked,
    };

    const isExternalLink = checkIsAbsoluteUrl(href);

    if (isExternalLink) {
      btnProps = {
        href,
        onClick: () => handleExternalLinkClicked(href),
        target: '_blank',
      };
    }

    return (
      <Button className="banner-dynamic__button" size="large" color="primary" {...btnProps}>
        {data.cta_text}
      </Button>
    );
  }

  const btnComp = getButton();
  const imgComp = getImg();

  return (
    <Container className="banner-dynamic">
      <Grid container spacing={3}>
        <Grid item xs={12} sm={8} md={9}>
          <div className="banner-dynamic__content-left">
            {!!data.title && (
              <Typography className="banner-dynamic__title" variant="h6">
                {data.title}
              </Typography>
            )}
            {!!data.description && (
              <Typography className="banner-dynamic__text p5">{data.description}</Typography>
            )}
            {btnComp}
          </div>
        </Grid>
        <Grid className="banner-dynamic__section-right" item xs={12} sm={4} md={3}>
          <div className="banner-dynamic__image">{imgComp}</div>
        </Grid>
      </Grid>
    </Container>
  );
};

BannerDynamic.defaultProps = {
  link: '',
  analyticsProps: {},
};

BannerDynamic.propTypes = {
  data: PropTypes.object.isRequired,
  link: PropTypes.string,
  analyticsLocation: PropTypes.string.isRequired,
  analyticsProps: PropTypes.object,
};

export default React.memo(BannerDynamic);
